  (function() {
    'use strict';

    // Helper function to get day suffix (st, nd, rd, th)
    function getDaySuffix(day) {
      if (day >= 11 && day <= 13) {
        return 'th';
      }
      switch (day % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
      }
    }

    // Check if we're in weekend mode (Friday 12PM onwards through Sunday)
    function isWeekendMode(aedtTime) {
      const dayOfWeek = aedtTime.getDay();
      const hours = aedtTime.getHours();

      // Friday from 12PM onwards, all Saturday, all Sunday
      if ((dayOfWeek === 5 && hours >= 12) || dayOfWeek === 6 || dayOfWeek === 0) {
        return true;
      }
      return false;
    }

    // Get next Monday date
    function getNextMonday(aedtTime) {
      const dayOfWeek = aedtTime.getDay();
      let daysUntilMonday;

      if (dayOfWeek === 5) {
        daysUntilMonday = 3; // Friday to Monday
      } else if (dayOfWeek === 6) {
        daysUntilMonday = 2; // Saturday to Monday
      } else if (dayOfWeek === 0) {
        daysUntilMonday = 1; // Sunday to Monday
      }

      const monday = new Date(aedtTime);
      monday.setDate(aedtTime.getDate() + daysUntilMonday);
      return monday;
    }

    function updateDeliveryCountdowns() {
      // Update badges on product images (collection pages)
      const badges = document.querySelectorAll('.pws-delivery-countdown');

      badges.forEach(badge => {
        const cutoffHour = parseInt(badge.getAttribute('data-cutoff-hour'));
        const cutoffMinute = parseInt(badge.getAttribute('data-cutoff-minute'));
        const textElement = badge.querySelector('.delivery-countdown-text');

        if (!textElement) return;

        // Get current time in UTC
        const now = new Date();
        const utcTime = now.getTime() + (now.getTimezoneOffset() * 60000);

        // Convert to AEDT (UTC+11)
        const aedtOffset = 11 * 60 * 60 * 1000;
        const aedtTime = new Date(utcTime + aedtOffset);

        let deliveryMessage;

        // Check if we're in weekend mode
        if (isWeekendMode(aedtTime)) {
          // Weekend mode: Show "Receive it MONDAY"
          deliveryMessage = 'Receive it MONDAY';
          textElement.textContent = deliveryMessage;
          badge.style.backgroundColor = '#28a745';
          return;
        }

        // Weekday mode: Original logic
        // Create cutoff time for today
        const cutoffToday = new Date(aedtTime);
        cutoffToday.setHours(cutoffHour, cutoffMinute, 0, 0);

        let targetCutoff;
        let deliveryType;

        // Check if we're before or after cutoff
        if (aedtTime < cutoffToday) {
          // Before cutoff - count down to today's cutoff for SAME DAY
          targetCutoff = cutoffToday;
          deliveryType = 'SAME DAY';
        } else {
          // After cutoff - count down to tomorrow's cutoff for NEXT DAY
          const cutoffTomorrow = new Date(aedtTime);
          cutoffTomorrow.setDate(cutoffTomorrow.getDate() + 1);
          cutoffTomorrow.setHours(cutoffHour, cutoffMinute, 0, 0);
          targetCutoff = cutoffTomorrow;
          deliveryType = 'NEXT DAY';
        }

        // Calculate time remaining until target cutoff
        const timeRemaining = targetCutoff - aedtTime;

        const hours = Math.floor(timeRemaining / (1000 * 60 * 60));
        const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

        const hoursStr = String(hours).padStart(2, '0');
        const minutesStr = String(minutes).padStart(2, '0');
        const secondsStr = String(seconds).padStart(2, '0');

        // Convert delivery type to simpler format
        deliveryMessage = deliveryType === 'SAME DAY' ? 'Receive it TODAY' : 'Receive it TOMORROW';

        textElement.textContent = `${deliveryMessage} ${hoursStr}:${minutesStr}:${secondsStr}`;
        badge.style.backgroundColor = '#28a745';
      });

      // Update analytics section countdown
      const analyticsBadges = document.querySelectorAll('.delivery-countdown-analytics');

      analyticsBadges.forEach(badge => {
        const cutoffHour = parseInt(badge.getAttribute('data-cutoff-hour'));
        const cutoffMinute = parseInt(badge.getAttribute('data-cutoff-minute'));

        // Get current time in UTC
        const now = new Date();
        const utcTime = now.getTime() + (now.getTimezoneOffset() * 60000);

        // Convert to AEDT (UTC+11)
        const aedtOffset = 11 * 60 * 60 * 1000;
        const aedtTime = new Date(utcTime + aedtOffset);

        // Check if this is an announcement-only badge
        const isAnnouncementOnly = badge.classList.contains('delivery-announcement-only');

        if (isAnnouncementOnly) {
          // Update announcement version
          const timeLabel = badge.querySelector('.delivery-countdown-time');
          const typeLabel = badge.querySelector('.delivery-type-label');
          const dateLabel = badge.querySelector('.delivery-date');

          // Check if we're in weekend mode
          if (isWeekendMode(aedtTime)) {
            // Weekend mode: Show MONDAY delivery, hide countdown
            const mondayDate = getNextMonday(aedtTime);
            const day = mondayDate.getDate();
            const daySuffix = getDaySuffix(day);
            const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
                               'July', 'August', 'September', 'October', 'November', 'December'];
            const month = monthNames[mondayDate.getMonth()];
            const formattedDate = `${day}${daySuffix} ${month}`;

            if (typeLabel) {
              typeLabel.textContent = 'MONDAY';
            }

            if (dateLabel) {
              dateLabel.textContent = formattedDate;
            }

            // Hide the countdown timer during weekend
            if (timeLabel && timeLabel.parentElement) {
              timeLabel.parentElement.style.display = 'none';
            }
          } else {
            // Weekday mode: Show countdown timer
            if (timeLabel && timeLabel.parentElement) {
              timeLabel.parentElement.style.display = '';
            }

            // Create cutoff time for today
            const cutoffToday = new Date(aedtTime);
            cutoffToday.setHours(cutoffHour, cutoffMinute, 0, 0);

            let targetCutoff;
            let deliveryType;

            // Check if we're before or after cutoff
            if (aedtTime < cutoffToday) {
              // Before cutoff - count down to today's cutoff for SAME DAY
              targetCutoff = cutoffToday;
              deliveryType = 'SAME DAY';
            } else {
              // After cutoff - count down to tomorrow's cutoff for NEXT DAY
              const cutoffTomorrow = new Date(aedtTime);
              cutoffTomorrow.setDate(cutoffTomorrow.getDate() + 1);
              cutoffTomorrow.setHours(cutoffHour, cutoffMinute, 0, 0);
              targetCutoff = cutoffTomorrow;
              deliveryType = 'NEXT DAY';
            }

            // Calculate time remaining until target cutoff
            const timeRemaining = targetCutoff - aedtTime;

            const hours = Math.floor(timeRemaining / (1000 * 60 * 60));
            const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

            // Format with leading zeros
            const hoursStr = String(hours).padStart(2, '0');
            const minutesStr = String(minutes).padStart(2, '0');
            const secondsStr = String(seconds).padStart(2, '0');

            // Calculate delivery date
            const deliveryDate = deliveryType === 'SAME DAY' ? new Date(aedtTime) : new Date(aedtTime.getTime() + (24 * 60 * 60 * 1000));

            // Format date as "5th February"
            const day = deliveryDate.getDate();
            const daySuffix = getDaySuffix(day);
            const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
                               'July', 'August', 'September', 'October', 'November', 'December'];
            const month = monthNames[deliveryDate.getMonth()];
            const formattedDate = `${day}${daySuffix} ${month}`;

            if (timeLabel) {
              timeLabel.textContent = `${hoursStr}:${minutesStr}:${secondsStr}`;
            }

            if (typeLabel) {
              const deliveryWord = deliveryType === 'SAME DAY' ? 'TODAY' : 'TOMORROW';
              typeLabel.textContent = deliveryWord;
            }

            if (dateLabel) {
              dateLabel.textContent = formattedDate;
            }
          }
        } else {
          // Original animated badge format (if needed)
          const textElement = badge.querySelector('.delivery-countdown-text');
          if (!textElement) return;

          // Create cutoff time for today
          const cutoffToday = new Date(aedtTime);
          cutoffToday.setHours(cutoffHour, cutoffMinute, 0, 0);

          let targetCutoff;
          let deliveryType;

          // Check if we're before or after cutoff
          if (aedtTime < cutoffToday) {
            // Before cutoff - count down to today's cutoff for SAME DAY
            targetCutoff = cutoffToday;
            deliveryType = 'SAME DAY';
          } else {
            // After cutoff - count down to tomorrow's cutoff for NEXT DAY
            const cutoffTomorrow = new Date(aedtTime);
            cutoffTomorrow.setDate(cutoffTomorrow.getDate() + 1);
            cutoffTomorrow.setHours(cutoffHour, cutoffMinute, 0, 0);
            targetCutoff = cutoffTomorrow;
            deliveryType = 'NEXT DAY';
          }

          // Calculate time remaining until target cutoff
          const timeRemaining = targetCutoff - aedtTime;

          const hours = Math.floor(timeRemaining / (1000 * 60 * 60));
          const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

          const hoursStr = String(hours).padStart(2, '0');
          const minutesStr = String(minutes).padStart(2, '0');
          const secondsStr = String(seconds).padStart(2, '0');

          textElement.innerHTML = `<span class="delivery-type-text">${deliveryType} DELIVERY</span><span class="delivery-countdown-timer">${hoursStr}:${minutesStr}:${secondsStr}</span>`;
        }
      });
    }

    // Update immediately on load
    updateDeliveryCountdowns();

    // Update every second
    setInterval(updateDeliveryCountdowns, 1000);

    // Also update when the page becomes visible again
    document.addEventListener('visibilitychange', function() {
      if (!document.hidden) {
        updateDeliveryCountdowns();
      }
    });
  })();